var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("buy-modal"),
      _c("section", { staticClass: "full__video" }, [
        _c(
          "div",
          {
            staticClass:
              "intro__content intro__content--mobile influencerlp--header"
          },
          [
            _c("img", {
              attrs: {
                id: "productLogo",
                srcset:
                  "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png" +
                  " 2x, " +
                  "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png" +
                  " 1x"
              }
            }),
            _c("h2", [
              _vm._v(
                "Cinemagraphs made easy. Pond5 contributors save 50% on an annual plan after a 30-day free trial. Don't miss this incredible chance to bring your stories to life!"
              )
            ]),
            _c(
              "div",
              { staticClass: "btn__group btn__group--splash" },
              [
                _c("buy-button", {
                  attrs: {
                    product: "monthTrial",
                    classes: "btn btn--purpleLight btn__splash",
                    coupon: "FLXPOND5",
                    copy: "Free Trial"
                  }
                })
              ],
              1
            )
          ]
        ),
        _c("div", { staticClass: "fluid__video" }, [
          _c(
            "div",
            {
              staticClass:
                "intro__content intro__content--desktop influencerlp--header"
            },
            [
              _c("img", {
                attrs: {
                  id: "productLogo",
                  srcset:
                    "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png" +
                    " 2x, " +
                    "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png" +
                    " 1x"
                }
              }),
              _c("h2", [
                _vm._v(
                  "Cinemagraphs made easy. Pond5 contributors save 50% on an annual plan after a 30-day free trial. Don't miss this incredible chance to bring your stories to life!"
                )
              ]),
              _c(
                "div",
                { staticClass: "btn__group btn__group--splash" },
                [
                  _c("buy-button", {
                    attrs: {
                      product: "monthTrial",
                      classes: "btn btn--purpleLight btn__splash",
                      coupon: "FLXPOND5",
                      copy: "Free Trial"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._m(0),
          _vm._m(1)
        ])
      ]),
      _c("section", [
        _c("div", { staticClass: "product__section" }, [
          _c("div", { staticClass: "product__section--container" }, [
            _c("div", { staticClass: "product__section--content" }, [
              _vm._m(2),
              _c("div", { staticClass: "productItem__desc" }, [
                _c("p", [
                  _vm._v(
                    "Cinemagraphs are the new visual medium captivating audiences across photography, social media and digital marketing. And now, creating professional quality cinemagraphs with multiple variations is possible in minutes. Simply import your video into Cinemagraph Pro and let the magic begin. Sign up for a FREE 30-day trial and save 50% on a Flixel Plan. Your membership gives you access to the world’s best cinemagraph creation tools and web services, exclusive to the POND5 community."
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "btn__group" },
                  [
                    _c("buy-button", {
                      attrs: {
                        product: "monthTrial",
                        classes: "btn btn--purpleLight btn__splash",
                        coupon: "FLXPOND5",
                        copy: "Free Trial"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("img", {
                staticClass: "lazy",
                attrs: {
                  id: "designaward",
                  "data-srcset":
                    "https://cdn.flixel.com/static/static-web/awards/awardada@2x.png 2x ,https://cdn.flixel.com/static/static-web/awards/awardada.png 1x"
                }
              })
            ]),
            _vm._m(3)
          ])
        ])
      ]),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm._m(7),
      _c("section", { staticClass: "influencerlp" }, [
        _c("div", { staticClass: "product__callout" }, [
          _c("div", { staticClass: "callout--container" }, [
            _c("h1", [_vm._v("Bring Your Stories to Life with Cinemagraphs")]),
            _c("p", [
              _vm._v(
                "Cinemagraphs continue to be named a top photography and design trend in 2019 and are highly in demand from marketers and top brands. Take your visual storytelling to the next level with the world’s best cinemagraph tools."
              )
            ]),
            _c(
              "div",
              { staticClass: "btn__group" },
              [
                _c("buy-button", {
                  attrs: {
                    product: "monthTrial",
                    classes: "btn btn--purpleLight btn__splash",
                    coupon: "FLXPOND5",
                    copy: "Free Trial"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._m(8),
      _vm._m(9),
      _c("section", { staticClass: "flixelPlan__section" }, [
        _c("div", { staticClass: "flixelPlan__container" }, [
          _c("h1", [_vm._v("Get all the apps with the Flixel Plan")]),
          _c("p", [
            _vm._v(
              "A Flixel plan gives you access to Cinemagraph Pro for macOS and iOS, Persecond for macOS, Blendeo for iOS, plus the world's leading service for hosting and sharing your HD quality cinemagraphs on the web and social networks."
            )
          ]),
          _c(
            "div",
            { staticClass: "btn__group" },
            [
              _c("buy-button", {
                attrs: {
                  product: "monthTrial",
                  classes: "btn btn--purpleLight btn__splash",
                  coupon: "FLXPOND5",
                  copy: "Free Trial"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video__overlay" }, [
      _c("iframe", {
        attrs: {
          src:
            "https://media.flixel.com/cinemagraph/d1ilqv8otic60s1c08fv?hd=true",
          allow: "autoplay"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "credit" }, [
      _c(
        "a",
        { attrs: { target: "_blank", href: "https://flixel.com/Ixhumni/" } },
        [_vm._v("Ixhumni")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "productItem__title" }, [
      _c("h2", [_vm._v("Make Money Selling Cinemagraphs")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "product__section--cinemagraph cpCinemagraph" },
      [
        _c("div", { staticClass: "fluid__video" }, [
          _c("iframe", {
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/0ryeqmkxv7xgqxdwdgt2?hd=false"
            }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "influencerlp__ios" }, [
      _c("div", { staticClass: "product__section product__section--ios" }, [
        _c(
          "div",
          {
            staticClass: "product__section--container product__section--reverse"
          },
          [
            _c("div", { staticClass: "product__section--content" }, [
              _c("div", { staticClass: "productItem__title" }, [
                _c("h2", [_vm._v("Cinemagraphs are Easy to Create")])
              ]),
              _c("div", { staticClass: "productItem__desc" }, [
                _c("p", [
                  _vm._v(
                    "Long-form video requires more time, skills, and resources to produce and is not as effective on social media. You only need perfectly still video footage and Cinemagraph Pro to easily create content that stands out and drives results. Record video capturing repeated motion or purchase stock footage that can easily be transformed in Cinemagraph Pro. If you've ever recorded a video on a tripod, there's a good chance you already have suitable content for creating cinemagraphs!"
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "product__section--image" }, [
              _c("img", {
                attrs: {
                  id: "iosImage",
                  srcset:
                    "https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios@2x.png" +
                    " 2x, " +
                    "https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios.png" +
                    " 1x"
                }
              })
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "influencerlp" }, [
      _c("div", { staticClass: "landingPage__section--container" }, [
        _c("div", { staticClass: "landingPage__section--content" }, [
          _c("h1", [_vm._v("Cinemagraphs Perform Better Than Still Photos")]),
          _c("p", [
            _vm._v(
              "Cinemagraphs capture and hold the attention of online audiences by isolating a single element for movement while the rest of the image remains still. Case studies show that cinemagraphs receive up to 51x higher engagement than still photos, making them the perfect medium for social media, websites, digital displays and more."
            )
          ]),
          _c("a", { attrs: { href: "https://flixel.com/case-studies/" } }, [
            _vm._v("Case Studies")
          ])
        ]),
        _c("div", { staticClass: "landingPage__section--image" }, [
          _c("img", {
            attrs: {
              srcset:
                "https://cdn.flixel.com/static/static-web/influencerlp/pepsistats@2x.png" +
                " 2x, " +
                "https://cdn.flixel.com/static/static-web/influencerlp/pepsistats.png" +
                " 1x"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "landingPage__section--marketers" }, [
      _c("div", { staticClass: "landingPage__section--video" }, [
        _c("h2", [
          _vm._v("Buy Cinemagraphs for Digital Marketing Campaigns & More")
        ]),
        _c("div", { staticClass: "video video__pond5" }, [
          _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                height: "0",
                "padding-bottom": "59.97%",
                width: "100%"
              }
            },
            [
              _c("iframe", {
                staticStyle: {
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                  "pointer-events": "all"
                },
                attrs: {
                  src:
                    "https://www.youtube.com/embed/71bPMCWlimI?rel=0&amp;showinfo=0",
                  showinfo: "0",
                  frameborder: "0",
                  allow: "autoplay"
                }
              })
            ]
          )
        ]),
        _c("p", [
          _vm._v(
            "Don't want to create your own cinemagraphs? No problem! Explore Pond5's "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.pond5.com/collections/2340239-cinemagraphs"
              }
            },
            [_vm._v("curated collection of cinemagraphs")]
          ),
          _vm._v(
            " or search for thousands of others using keywords. Their library includes 700+ cinemagraphs created by Flixel Wizard Alexandre Miguel whose breathtaking landscapes inspire online audiences all over the world."
          )
        ]),
        _c("div", { staticClass: "btn__group" }, [
          _c(
            "a",
            { attrs: { href: "https://www.pond5.com/artist/flixel#1/2063" } },
            [
              _c(
                "button",
                { staticClass: "btn btn--purpleLight btn__splash" },
                [_vm._v("Flixel Collection")]
              )
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "landingPage__section--marketers" }, [
      _c("div", { staticClass: "landingPage__section--video" }, [
        _c("h2", [_vm._v("Create Long Exposure Videos with Blendeo")]),
        _c("div", { staticClass: "video video__pond5" }, [
          _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                height: "0",
                "padding-bottom": "59.97%",
                width: "100%"
              }
            },
            [
              _c("iframe", {
                staticStyle: {
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                  "pointer-events": "all"
                },
                attrs: {
                  src:
                    "https://www.youtube.com/embed/CDHyoRnrGuc?rel=0&amp;showinfo=0",
                  showinfo: "0",
                  frameborder: "0",
                  allow: "autoplay"
                }
              })
            ]
          )
        ]),
        _c("p", [
          _vm._v(
            "Take the chance and guesswork out of creating beautiful long exposures with Blendeo, our new long exposure photo and video editor for iOS. Change the exposure time after capture to create mesmerizing light trails, soften water and clouds, blend transient objects, and more."
          )
        ]),
        _c("div", { staticClass: "btn__group" }, [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://blog.flixel.com/introducing-blendeo-long-exposure-app"
              }
            },
            [
              _c(
                "button",
                { staticClass: "btn btn--purpleLight btn__splash" },
                [_vm._v("Learn more")]
              )
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "product__section product__section--carousel" },
      [
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--wide" },
          [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/t1d1hq1xjbsxc2dxz6g1?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--thin" },
          [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/fmou1dsz9f44agosgkbj?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--wide" },
          [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/nrldxc67hri302eescck?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c("div", { staticClass: "carousel--mobile" }, [
          _c("iframe", {
            attrs: {
              "data-src":
                "https://media.flixel.com/cinemagraph/t1d1hq1xjbsxc2dxz6g1?hd=true",
              allow: "autoplay"
            }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "carousel__attributions" }, [
      _c("h2", [_vm._v("Check out more by the artists featured here.")]),
      _c("div", { staticClass: "attributions" }, [
        _c(
          "a",
          {
            attrs: { href: "https://flixel.com/mrjonkane/", target: "_blank" }
          },
          [_vm._v("mrjonkane")]
        ),
        _c(
          "a",
          {
            attrs: { href: "https://flixel.com/VirgoHaan/", target: "_blank" }
          },
          [_vm._v("VirgoHaan")]
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://flixel.com/michelmolder/",
              target: "_blank"
            }
          },
          [_vm._v("michelmolder")]
        )
      ]),
      _c("div", { staticClass: "attributions--mobile" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://flixel.com/michelmolder/",
              target: "_blank"
            }
          },
          [_vm._v("michelmolder")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ad7cb31", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad7cb31","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/landingPages/offers/pond5/pond5.vue
// module id = null
// module chunks = 